import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userinfo: [],
    shoplist: [],
    productinfo: [],
    orderinfo: [],
    starpoint: [],
  },
  mutations: {
    setUserinfoData(state, userinfoData) {
      state.userinfo = userinfoData;
    },
    setShoplistData(state, shoplistData) {
      state.shoplist = shoplistData;
    },
    setProductinfoData(state, productinfoData) {
      // state.productid = productidData;
      state.productinfo = productinfoData;
    },
    // 儲存訂購人地址
    setOrderinfoData(state, orderinfoData) {
      state.orderinfo = orderinfoData;
    },
    // 儲存收件人地址
    setRecinfoData(state, recinfoData) {
      state.recinfo = recinfoData;
    },
    // 此商品可使用星幣&使用者擁有星幣
    setStarPointData(state, starpointData) {
      state.starpoint = starpointData;
    },
  },
  actions: {
  },
  modules: {
  }
})
